import './RecurringEarningsWidget.scss';

import React, { useCallback, useEffect, useState } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Text from 'fe-design-base/atoms/Text';
import { fromJS } from 'immutable';
import PropTypes from 'prop-types';

import Box from 'components/Box';

import { cxHelpers } from 'util/className';

import RecurringEarningsList from './RecurringEarningsList';

const { cx } = cxHelpers('RecurringEarningsWidget');

const RecurringEarningsWidget = ({
  user,
  updateUserInfo,
  showFormWithSteps,
}) => {
  const [userObj, setUserObj] = useState(user);

  useEffect(() => {
    setUserObj(fromJS(user));
  }, [user]);

  const handleOnSaveCompleted = useCallback(response => {
    setUserObj(fromJS(response));
    return response;
  }, []);

  if (!user.get('show_recurring_earnings_and_reimbursements')) return null;

  return (
    <Box className={cx()} mb={32}>
      <Box mb={12}>
        <Text
          variant={showFormWithSteps ? 'heading4' : 'heading3'}
          i18n="team.employee_profile.recurring_earnings.title"
          color={showFormWithSteps && 'mono900'}
        />
      </Box>
      <Box b={!showFormWithSteps} pb={8} row bradius>
        <Box grow={2}>
          <RecurringEarningsList
            user={userObj}
            updateUserInfo={updateUserInfo}
            onSaveCompleted={handleOnSaveCompleted}
            showFormWithSteps={showFormWithSteps}
          />
        </Box>
      </Box>
    </Box>
  );
};

RecurringEarningsWidget.propTypes = {
  user: ImmutablePropTypes.map.isRequired,
  updateUserInfo: PropTypes.func.isRequired,
};

export default RecurringEarningsWidget;
